<div class="dashboard-box">
  <div class="dashboard-box__header">
    <h3 class="dashboard-box__heading" *ngIf="heading">{{heading}}</h3>
  </div>
  <div class="dashboard-box__body">
    <ng-content></ng-content>
  </div>
</div>
